/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInventoryInCommandResult } from '../../models/create-inventory-in-command-result';

export interface ApiNurseryManagerInventoryInCreateInventoryInPost$Plain$Params {
      body?: {
'ItemId'?: string;
'StoreId'?: string;
'Quantity'?: number;
'ReceiverId'?: string;
'SupervisorId'?: string;
}
}

export function apiNurseryManagerInventoryInCreateInventoryInPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryInCreateInventoryInPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryInCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryInCreateInventoryInPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateInventoryInCommandResult>;
    })
  );
}

apiNurseryManagerInventoryInCreateInventoryInPost$Plain.PATH = '/api/NurseryManager/InventoryIn/CreateInventoryIn';
